import * as React from "react";
import { useContext } from "react";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import {ValueContext} from '~common/components/form-def-field-fc';
import {ICGFormControl} from '~common/components/icg-form-control';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    displayText: {
        marginTop: 16,
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
  })
);

interface JsonProps {
  fieldDefinition: any;
  policyMessages?: any;
  readOnlyOverride?: boolean;
}

export const JsonField: React.FC<JsonProps> = ({
  fieldDefinition,
  policyMessages,
  readOnlyOverride,
}) => {
  const classes = useStyles();    

  var parentContext = ValueContext
    
  const [fieldValue] = useContext(parentContext);

  return (
    <ICGFormControl 
        fieldDefinition={fieldDefinition} 
        policyMessages={policyMessages} 
        readOnlyOverride={readOnlyOverride} 
        > 
        <div name={fieldDefinition.key} className={classes.displayText}>
            {fieldValue ? JSON.stringify(fieldValue, null, 2) : "-"}
            </div>
    </ICGFormControl>
  );
};

export default JsonField;
